// components/Tabs/MissionTakerTabs.jsx

import React from 'react';
// Import your CSS module
import styles from './MissionTakerTabs.module.css';

/**
 * MissionTakerTabs is a simple tab layout for the Mission Taker flow.
 * - steps: an array of labels for each step (e.g. ['Naming', 'Description', 'Physics', 'Media']).
 * - activeStep: the index of the currently active step.
 * - setActiveStep: function to change the active step index.
 * - children: the content for each step, typically conditionally rendered in your parent.
 */
export default function MissionTakerTabs({ steps, activeStep, setActiveStep, children }) {
  // Handler for tab clicks, just sets the active step in the parent
  const handleTabClick = (index) => {
    setActiveStep(index);
  };

  return (
    <div className={styles.tabs}>
      {/* Tab Navigation (Buttons) */}
      <div className={styles['tab-links']}>
        {steps.map((label, index) => (
          <button
            key={index}
            className={`${styles['tab-link']} ${activeStep === index ? styles.active : ''}`}
            onClick={() => handleTabClick(index)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className={styles['tab-content']}>
        {children}
      </div>
    </div>
  );
}
